import { RouteAuthenticationRequirement, RouteItem } from '@cksoftware/react-base';
import { AppRoles } from '../constants/appRoles.ts';
import { ApplicationRoutes } from '../constants/appRoutes.ts';
import { Layout } from '../components/layout/layout.tsx';

export const ManageAuctionRoutes: RouteItem = {
  text: 'Manage Auctions',
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [AppRoles.Admin],
  path: ApplicationRoutes.crm.auctions,
  layout: <Layout />,
  async lazy() {
    const component = await import('../features/auctions/ManageAuctions');
    return { Component: component.ManageAuctions };
  }
};
